import React from 'react'
import { useLocation, Navigate, Outlet } from "react-router-dom";

const RequireSite = () => {

    const chosenSiteId = localStorage.getItem('site')
    const location = useLocation()

    return (
        chosenSiteId ? <Outlet /> : <Navigate to="/choosesite" state={{ from: location }} replace />
    );
}

export default RequireSite
